import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';

import { getPrice } from '../booking/modules/helpers'; // eslint-disable-line no-unused-vars
import Rounds from '../booking/classes/Rounds';

import DMP from '../booking/classes/DMP';
import gms from '../store/gms';

Vue.component('booking-overview-component', {
    props: {
        locale: {
            type: String,
        },
    },

    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            rounds: new Rounds(this),
            dmp: new DMP(this),
            gms,
        };
    },

    computed: {
        ...mapState('reservation', {
            participants: (state) => state.participants,
            month: (state) => state.month,
            date: (state) => state.date,
            booker: (state) => state.booker,
            activeRound: (state) => state.activeRound,
            confirmed: (state) => state.confirmed,
        }),

        ...mapState('member', {
            memberProfile: (state) => state.profile,
        }),
    },

    watch: {
        booker(value) {
            if (this.booker.confirmed && !this.gms.visit) {
                this.findVisit();
            }
        },
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        //
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
        ...mapMutations('reservation', [
            'setConfirmed',
        ]),

        onChangeBookingClick() {
            this.$modals.$emit('show-modal:reset-booking', this.reset.bind(this));
        },

        /**
         * Resets the booking component.
         *
         * @returns {Void}
         */
        reset() {
            window.onbeforeunload = null;
            window.location.reload();
        },

        findVisit() {
            this.$api.gms.reservation.findVisit(this.gms.visitId)
            .then((response) => {
                this.$set(this.gms, 'visit', response);
                // this.gms.visit = response;
                // window.raiseFacebookPageView();

                // window.raiseGtmPageview('Step 7 - Booking Overview');
            });
        },

        getPrice,

        /**
         *
         * Makes the visit definitive and, if succesfull,
         * sets the component in the 'confirmed' state.
         *
         * @returns {Void}
         */
        confirmVisit() {
            this.updating = true;

            this.$api.gms.reservation.makeVisitDefinitive(this.gms.visitId)
            .then((response) => {
                this.updating = false;

                // Catch error from GMS.
                const result = response.data;
                if (!result.success) {
                    const message = result.result.errors.message ?? 'A technical error occurred while trying to confirm the booking.';
                    alert(message);
                    return;
                }

                this.setConfirmed(true);

                if (this.booker.register) {
                    this.createAccount();
                }
            })
            .catch((error) => {
                this.updating = false;
                alert(error);
            });
        },

        /**
         * Register the daymember with the GMS.
         *
         * @returns {Void}
         */
        createAccount() {
            this.$api.gms.account.createDaymemberAccount({
                uuid: this.booker.uuid,
                password: this.booker.password,
            })
            .then((response) => {
                console.log(response);
            })
            .catch((error) => {
                console.log(error);
            });
        },

        claimDmp(value, key) {
            this.dmp.dmpClaim[key] = value;
            this.dmp.claimDmp();
        },
    },
});
